/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebreviewtitle3Inputs */

const en_placewebreviewtitle3 = /** @type {(inputs: Placewebreviewtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here is your place.`)
};

const de_placewebreviewtitle3 = /** @type {(inputs: Placewebreviewtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist dein Ort.`)
};

/**
* | output |
* | --- |
* | "Here is your place." |
*
* @param {Placewebreviewtitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebreviewtitle3 = /** @type {((inputs?: Placewebreviewtitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebreviewtitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebreviewtitle3(inputs)
	return de_placewebreviewtitle3(inputs)
});
export { placewebreviewtitle3 as "placeWebReviewTitle" }